<template>
  <Navigator
    :back-action="routerBack"
    :replace-back="replaceBack"
    :replace-to="replaceTo"
  />
  <main
    class="main-container"
    :style="{ 'min-height': `calc(100vh - ${navbarHeight}px)` }"
  >
    <RouterView class="router-view" @toggle-overlay="toggleOverlay" />
  </main>
  <Overlay v-if="isOverlayShow" />
  <Loading v-if="isLoading" />
  <Dialog
    v-model:show="showDialog"
    :action="dialogAction"
    :no-phone-number="noPhoneNumber"
  >
    {{ dialogMessage }}
  </Dialog>
  <Alert
    v-model:show="showAlert"
    :message="alertMessage"
    :action="alertAction"
    :single-button="alertSingleButton"
    :confirm-text="alertConfirmText"
    :cancel-text="alertCancelText"
  />
</template>

<script>
import api from '../api';
import emitter from '../helpers/emitter';
import { ref, computed, onMounted, onUpdated, watch } from 'vue';
import { RouterView, useRouter, useRoute } from 'vue-router';
import { useStore } from 'vuex';
import Overlay from '../components/Overlay.vue';
import Loading from '../components/Loading.vue';
import Dialog from '../components/Dialog.vue';
import Alert from '../components/Alert.vue';
import Navigator from '../components/Navigator.vue';
import { init } from '../helpers/siteLoader';
import { isLoading } from '../helpers/loading.js';

export default {
  name: 'App',
  components: {
    RouterView,
    Overlay,
    Loading,
    Dialog,
    Alert,
    Navigator,
  },
  setup() {
    const router = useRouter();
    const route = useRoute();
    const store = useStore();

    const memberCode = computed(() => route.query.m);
    const token = computed(() => route.query.t);

    watch(memberCode, () => {
      store.commit('setMemberCode', memberCode.value);
    });
    watch(token, () => {
      store.commit('setToken', token.value);
    });

    const routerBack = () => {
      router.back();
    };
    const navbarHeight = ref(0);

    const noPhoneNumber = ref(false);

    const replaceBack = computed(() => !!route.meta.replaceTo);
    const replaceTo = computed(() => route.meta.replaceTo);

    emitter.on('callMessager', (data) => callMessager(data));
    const showDialog = ref(false);
    const dialogMessage = ref('');
    const dialogAction = ref(() => {});
    const callMessager = (data) => {
      showDialog.value = true;
      dialogMessage.value = data.message;
      dialogAction.value = data.action;
      noPhoneNumber.value = data.noPhoneNumber || false;
    };

    emitter.on('callAlert', (data) => callAlert(data));
    const showAlert = ref(false);
    const alertMessage = ref('');
    const alertAction = ref(() => {});
    const alertSingleButton = ref(false);
    const alertConfirmText = ref('');
    const alertCancelText = ref('');
    const callAlert = (data) => {
      showAlert.value = true;
      alertMessage.value = data.message;
      alertAction.value = data.action;
      alertSingleButton.value = data.singleButton;
      alertConfirmText.value = data.buttonText?.confirm;
      alertCancelText.value = data.buttonText?.cancel;
    };

    const isOverlayShow = ref(false);
    const toggleOverlay = () => {
      isOverlayShow.value = !isOverlayShow.value;
    };

    onMounted(() => {
      const nav = document.querySelector('.navigator.navbar');
      if (nav) {
        navbarHeight.value = nav.clientHeight;
      }
    });

    onUpdated(() => {
      init(api);
    });

    return {
      routerBack,
      showDialog,
      showAlert,
      isOverlayShow,
      toggleOverlay,
      isLoading,
      dialogMessage,
      dialogAction,
      noPhoneNumber,
      alertMessage,
      alertAction,
      alertSingleButton,
      alertConfirmText,
      alertCancelText,
      replaceBack,
      replaceTo,
      navbarHeight,
    };
  },
};
</script>

<style lang="scss">
#app {
  .main-container {
    width: 100%;
    .router-view {
      height: 100%;
      width: 100%;
    }
  }
}

* {
  -webkit-touch-callout: none; /*系統預設選單被禁用*/
  -webkit-user-select: none; /*webkit瀏覽器*/
  -khtml-user-select: none; /*早期瀏覽器*/
  -moz-user-select: none; /*火狐*/
  -ms-user-select: none; /*IE10*/
  user-select: none;
  touch-action: pan-x pan-y;
}
</style>
